<template>
<el-dialog
  :visible='true'
  :title="type == 1 ? '选择素材-图片':'选择素材-视频'"
  :before-close='handleClose'
  width='940px'
  :append-to-body="true"
>
  <div class="" v-loading="loading">
    <el-checkbox-group v-model="checks" :max="max" style="display: flex;flex-wrap: wrap;">
      <div v-for="item in sourceList" :key="item.id" :class="type == 1 ? 'source-item' : 'source-video'">
        <el-image v-if="type == 1" :src="item.mulitiFileDatas.fileUrl" :preview-src-list="[item.mulitiFileDatas.fileUrl]" alt="" class="item-pic"></el-image>
        <video v-if="type == 2" class="item-video" id="myvideo" controlslist="nodownload"
          ref="curVideo" preload="auto" controls="controls">
          <source :src="item.mulitiFileDatas.fileUrl" type="video/mp4">
        </video>
        <div class="item-title">{{ item.mediaName }}</div>
        <el-checkbox class="item-check" :label="item.id" ></el-checkbox>
      </div>
    </el-checkbox-group>
  </div>
  <template #footer>
    <div class='dialog-bottom' >
      <el-button @click='handleClose' type='secondary' size='small'>取消</el-button>
      <el-button @click='handleConfirm' type='primary' size='small'>确定</el-button>
    </div>
  </template>
</el-dialog>
</template>

<script>
import { getCardValidFileList } from '@/api/backstage/smsCard'
export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
  type:{
    type:Number,
    default:1
  },
  ids:{
    type:Array,
    default: [],
  },
  max:{
    type:Number,
    default:1
  }
 },
 data() {
 return {
  loading:true,
  sourceList:[
  ],
  checks:[],
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
  
  getCardValidFileList({mediaType:this.type}).then(res=>{
    this.loading = false;
    if(res.code == 1){
      this.sourceList = res.data
    }else{
      this.$message.warning(res.message)
    }
  })
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
    if(!this.checks.length) {
      this.$message.warning('请选择素材')
      return
    }
    let urlList = [];
    this.sourceList.forEach(item=>{
      if(this.checks.find(it=>item.id == it)){
        urlList.push(item.mulitiFileDatas.fileUrl);
      } 
    })
    this.$emit('confirm',{ids:this.checks,urlList});
  },
 }
}
</script>
<style lang='scss' scoped>
.dialog-bottom {
  text-align: right;
}

.source-item{
  width: 150px;
  height: 150px;
  border-radius: 8px 8px 8px 8px;
  overflow: hidden;
  position: relative;
  margin: 0px 20px 20px 0;
  .item-pic{
    position:absolute;
    width: 150px;
    height: 150px;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 2;
  }

  .item-title{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 28px;
    background: rgba(0,0,0,0.5);
    border-radius: 0px 0px 8px 8px;
    font-size: 14px;
    line-height: 28px;
    text-overflow: ellipsis;
    text-align: center;
    color: #ffffff;
    z-index: 3;
  }
  .item-check{
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 3;
  }
}
.source-video{
  width: 160px;
  height: 118px;
  border-radius: 8px 8px 8px 8px;
  overflow: hidden;
  position: relative;
  margin: 0px 20px 20px 0;
  .item-video{
    position:absolute;
    width: 160px;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 2;
  }

  .item-title{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 28px;
    background: rgba(0,0,0,0.5);
    border-radius: 0px 0px 8px 8px;
    font-size: 14px;
    line-height: 28px;
    text-overflow: ellipsis;
    text-align: center;
    color: #ffffff;
    z-index: 3;
  }
  .item-check{
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 3;
  }
}
/deep/ .el-checkbox__label{
  display: none;
}
</style>